export default __webpack_public_path__ + "static/media/video_effects_left_frame.c4314373.png";